import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { ConfirmDialogModel, ConfirmDialogPopupComponent, CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, getPDropdownData, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, onActionSubmittedUtil, PERMISSION_RESTRICTION_ERROR, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams, prepareRequiredHttpParams, PrimengConfirmDialogPopupComponent, PrimengStatusConfirmDialogComponent, ResponseMessageTypes, RxjsService, sidebarDataSelector$, SnackbarService, UserService } from '@app/shared';
import { PrimengDeleteConfirmDialogComponent } from '@app/shared/components/primeng-delete-confirm-dialog/primeng-delete-confirm-dialog.component';
import { DealerCommentsHistoryComponent, DealerDocumentDeclineReasonComponent, DealerDocumentsAddEditComponent, DealerPrincipleAddEditComponent } from '@modules/dealer';
import { DEALER_COMPONENT, DealerModuleApiSuffixModels } from '@modules/dealer/shared/enum/dealer.enum';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { DealerAVSCheckComponent } from '../dealer-avs-check/dealer-avs-check-component';
import { DealerCreditVettingComponent } from '../dealer-credit-vetting/dealer-credit-vetting-component';
@Component({
  selector: 'app-dealer-maintenance-list',
  templateUrl: './dealer-maintenance-list.component.html',
  styleUrls: ['./dealer-maintenance-list.component.scss']
})
export class DealerMaintenanceListComponent extends PrimeNgTableVariablesModel {

  isSubmitted: boolean;
  dealerId: any;
  dealerTypeId: any;
  referenceId: any;
  listSubscribtion: any;
  dateFormat = 'MMM dd, yyyy';
  observableResponse: any;
  obj: any;
  reset: boolean;
  psiraExpiryDate: any = new Date();
  showFailedImport: boolean = false;
  fileName = '';
  isFileSelected: boolean = false;
  isFileUpload: boolean = false;
  alertDialog: any;
  openDialogs = [];
  dealerDocumentSubscription: any;
  isDisableCreateButton: boolean;

  constructor(private crudService: CrudService, private rxjsService: RxjsService, private snackbarService: SnackbarService,
    private store: Store<AppState>, private dialogService: DialogService, private datePipe: DatePipe,
    private router: Router, private activatedRoute: ActivatedRoute, private dialog: MatDialog, private userService: UserService,) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: 'Dealer Maintenance',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Dealer Management', relativeRouterUrl: '' }, { displayName: 'Dealer Maintenance', relativeRouterUrl: '' }, { displayName: 'Dealer Info', relativeRouterUrl: '' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Dealer Info',
            dataKey: 'dealerId',
            enableAction: true,
            enableScrollable: true,
            enableHyperLink: true,
            enableFieldsSearch: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerIIPCode', header: 'Dealer Code', width: '100px' },
              { field: 'companyName', header: 'Company Name', width: '200px' },
              { field: 'dealerTypeName', header: 'Dealer Type', width: '140px', type: 'dropdown', options: [] },
              { field: 'startDate', header: 'Start Date', width: '100px', isDate: true, nofilter: true },
              { field: 'endDate', header: 'End Date', width: '100px', isDate: true, nofilter: true },
              { field: 'terminationDate', header: 'Termination Date', width: '150px', isDate: true, nofilter: true },
              { field: 'dealerTerminationReasonName', header: 'Termination Reason', width: '150px', nofilter: true },
              { field: 'status', header: 'Status', width: '150px', nofilter: true },
            ],
            enableBreadCrumb: true,
            enableAddActionBtn: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },
          {
            caption: 'Dealer Principal',
            dataKey: 'dealerId',
            enableAction: true,
            enableScrollable: true,
            disabled: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'principleName', header: 'Dealer Principal Name', width: '200px' },
              { field: 'principleSurname', header: 'Dealer Principal Surname', width: '200px' },
              { field: 'principleIDNumber', header: 'Dealer Principal ID No', width: '180px' },
              { field: 'principlePSIRARegNumber', header: 'PSIRA Reg Number', width: '160px' },
              { field: 'email', header: 'Email', width: '180px' },
              { field: 'contactNumber', header: 'Contact Number', width: '140px' },
              { field: 'isActive', header: 'Status', width: '100px' },
              { field: 'approvalStatus', header: 'Approval Status', width: '140px' },
            ],
            enableBreadCrumb: true,
            enableAddActionBtn: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_PRINCIPLE,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },
          {
            caption: 'Branch Details',
            dataKey: 'dealerBranchId',
            enableAction: true,
            enableScrollable: true,
            checkBox: true,
            disabled: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerBranchCode', header: 'Dealer Branch Code', width: '160px' },
              { field: 'branchName', header: 'Dealer Branch Name', width: '170px' },
              { field: 'managerName', header: 'Branch Manager Name', width: '200px' },
              { field: 'startDate', header: 'Start Date', width: '150px', isDate: true },
              { field: 'endDate', header: 'End Date', width: '150px', isDate: true },
              { field: 'emailAddress', header: 'Email Address', width: '150px' },
              { field: 'phoneNumber', header: 'Contact Number', width: '140px' },
              { field: 'status', header: 'Status', width: '80px' },
              { field: 'approvalStatus', header: 'Approval Status', width: '140px' },
            ],
            enableMultiDeleteActionBtn: true,
            enableBreadCrumb: true,
            enableAddActionBtn: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_BRANCH,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER_BRANCH_DELETE,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },
          {
            caption: 'Dealer Branch Category',
            dataKey: 'dealerBranchId',
            enableScrollable: true,
            disabled: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerBranchCode', header: 'Branch Code', width: '150px' },
              { field: 'dealerCategoryTypes', header: 'Category Type', width: '200px' },
              { field: 'attritionThresholdRate', header: 'Attrition Threshold Rate', width: '200px' },
              { field: 'sapVendorNoCatA', header: 'SAP Vendor Number(CAT:A)', width: '150px' },
              { field: 'sapVendorNoCatC', header: 'SAP Vendor Number(CAT:C)', width: '150px' },
              { field: 'commissionStartDate', header: 'Commission Start Date', width: '160px', isDate: true },
              { field: 'bonusMultipleStartDate', header: 'Bonus Multiple Start Date', width: '170px', isDate: true },
              { field: 'warehouseName', header: 'Warehouse Name', width: '200px' },
              { field: 'storageLocationName', header: 'Storage Location Name', width: '200px' },
              { field: 'techStockLocationNumber', header: 'Tech Stock Location Number', width: '200px' },
              { field: 'approvalStatus', header: 'Approval Status', width: '140px' },
            ],
            enableBreadCrumb: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_LIST,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_LIST,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },
          {
            caption: 'Dealer Documents',
            dataKey: 'dealerDocumentId',
            enableAction: true,
            enableScrollable: true,
            disabled: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'docName', header: 'Document', width: '200px' },
              { field: 'dealerDocumentTypeName', header: 'Document Type', width: '150px' },
              { field: 'approvalStatus', header: 'Approval Status', width: '140px' },
              { field: 'Update', header: 'Action', width: '100px', nofilter: true, isUpdateDelete: true, disabledKey: 'canEdit' },
            ],
            enableBreadCrumb: true,
            enableAddActionBtn: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_DOCUMENT,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER_DOCUMENT_DELETE,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },
        ]
      }
    }
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.dealerId = (Object.keys(params['params']).length > 0) ? params['params']['id'] : '';
      this.dealerTypeId = (Object.keys(params['params']).length > 0) ? params['params']['dealerTypeId'] : '';
      this.referenceId = (Object.keys(params['params']).length > 0) ? params['params']['referenceId'] : '';
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      if (this.selectedTabIndex == 0 && this.primengTableConfigProperties.breadCrumbItems[2]) {
        this.primengTableConfigProperties.breadCrumbItems.pop();
      }
      if (this.referenceId) {
        this.primengTableConfigProperties.breadCrumbItems[1]['relativeRouterUrl'] = '';
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].enableAddActionBtn = false;
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].enableMultiDeleteActionBtn = false;
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].checkBox = false;
      }
      if (this.referenceId && this.selectedTabIndex == 4) {
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].enableRowDelete = false;
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns = [
          { field: 'docName', header: 'Document', width: '150px' },
          { field: 'dealerDocumentTypeName', header: 'Document Type', width: '100px' },
          { field: 'reason', header: 'Comments', width: '150px', isInput: true },
          { field: 'approvalStatus', header: 'Action Status', width: '150px' },
          { field: 'dealerDocumentActionStatus', header: 'Action Status', width: '200px', isRadioBtn: true, options: [{ display: 'Accept', value: true }, { display: 'Reject', value: false }] },
          { field: 'viewResult', header: 'View Results', width: '100px', isUrlLink: true },
        ]
        this.pageSize = 10;
      }
      if (!this.referenceId && (this.selectedTabIndex == 1 || this.selectedTabIndex == 2)) {
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns[8] =
          { field: 'viewResult', header: 'View Results', width: '150px', isShowConditionUrlLink: true, conditionField: 'isMigrationDealer' };
        // { field: 'viewResult', header: 'View Results', width: '150px', isUrlLink: true };
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns[9] =
          { field: 'actionLabel', header: 'Action', width: '150px', isConditionButton: true, conditionField: 'isMigrationDealer', cssClassName: 'fdt-green-button cursor-pointer' };
        // { field: 'actionLabel', header: 'Action', width: '150px', isButton: true, cssClassName: 'fdt-green-button cursor-pointer' };
      }
      // Immanuel for breadcrumb and tab changes not workig issue start - so invoked in constructor
      this.onLoadPage();
      // Immanuel for breadcrumb and tab changes not workig issue end
    });
  }

  onLoadPage() {
    this.combineLatestNgrxStoreData();
    this.getDealerMaintenanceListData();
    this.onBreadCumbChange();
    if (this.selectedTabIndex != 0 && this.dealerId) {
      this.primengTableConfigProperties.tableComponentConfigs.tabsList.map(el => el.disabled = false);
    }
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$),
      this.store.select(sidebarDataSelector$)]).subscribe((response) => {
        this.loggedInUserData = new LoggedInUserModel(response[0]);
        let dealerManagement = response[2]?.['menuAccess']?.find(item => item.menuName == "Dealer Management");
        if (!dealerManagement) return "";
        let dealer = dealerManagement['subMenu']?.find(item => item.menuName == DEALER_COMPONENT.DEALER_MAINTENANCE);
        let permission = response[1][DEALER_COMPONENT.DEALER_MAINTENANCE] || dealer['subMenu']
        if (permission) {
          let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
          this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
        }
      });
    // Load dealer type dropdown options for column filter
    this.crudService.dropdown(ModulesBasedApiSuffix.DEALER,
      DealerModuleApiSuffixModels.DEALER_TYPE_DROPDOWN, prepareRequiredHttpParams({ isAll: false }))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns[2].options = getPDropdownData(response.resources, "displayName", "id");
        }
      });
  }

  getDealerDocumentTypeDropdown(params) {
    if (this.dealerDocumentSubscription && !this.dealerDocumentSubscription?.closed) {
      this.dealerDocumentSubscription.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.dealerDocumentSubscription = this.crudService.dropdown(
      ModulesBasedApiSuffix.DEALER,
      DealerModuleApiSuffixModels.DEALER_DOCUMENT_DROPDOWN,
      params,
    ).subscribe(data => {
      if (data.isSuccess && data.statusCode == 200) {
        this.openDealerDocumentDialog(data.resources, '', '25vh');
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {

    switch (type) {
      case CrudType.CREATE:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        // Handle column-level filter values
        if (unknownVar?.dealerTypeName) {
          unknownVar['dealerTypeId'] = unknownVar['dealerTypeName'];
          delete unknownVar['dealerTypeName'];
        }
        this.getDealerMaintenanceListData(this.row["pageIndex"], this.row["pageSize"], unknownVar)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EDIT:
        // if (this.selectedTabIndex == 1 && row && row?.viewResult == 'AVS Verification') {
        //   if (row.creditVettingStatus == true)
        //     this.openDealerPrincipleCreditVetting(CrudType.EDIT, row);
        //   else
        //     this.snackbarService.openSnackbar("Please Complete The Credit Vetting.", ResponseMessageTypes.WARNING);
        // }
        // else if (this.selectedTabIndex == 2 && row && row?.viewResult == 'AVS Verification') {
        //   if (row.avsCheckStatus == true)
        //     this.openDealerBranchAVSCheck(CrudType.EDIT, row);
        //   else
        //     this.snackbarService.openSnackbar("Please Complete The AVS Check.", ResponseMessageTypes.WARNING);
        // }
        this.openAddEditPage(CrudType.EDIT, row, unknownVar);
        break;
      case CrudType.STATUS_POPUP:
        this.onChangeStatus(row, unknownVar)
        break;
      case CrudType.ACTION:
        if (this.selectedTabIndex == 1) {
          // if (row.creditVettingStatus == true) // AS per the divya's comments alert is removed
          //   this.snackbarService.openSnackbar("The Credit Vetting Verification is completed already.", ResponseMessageTypes.WARNING);
          // else
          this.dealerCreditVetting(row);
        }
        else if (this.selectedTabIndex == 2)
          this.dealerCreditVettingAvsCheck(row);
        break;
      case CrudType.DELETE:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canRowDelete) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        } else {
          if (!row && this.selectedTabIndex == 2) {
            if (this.selectedRows.length == 0) {
              this.snackbarService.openSnackbar("Please select atleast one item to delete", ResponseMessageTypes.WARNING);
            } else if (row?.approvalStatus?.toLowerCase() != 'approved') {
              this.onOneOrManyRowsDelete();
            } else {
              this.snackbarService.openSnackbar("This request can't be deleted.", ResponseMessageTypes.WARNING);
            }
          } else if (row?.approvalStatus?.toLowerCase() != 'approved' && this.selectedTabIndex == 4) {
            this.onOneOrManyRowsDelete(row);
          } else {
            this.snackbarService.openSnackbar("This request can't be deleted.", ResponseMessageTypes.WARNING);
          }
        }
        break;
      default:
    }
  }
  dealerCreditVetting(val) {
    let finalObject = {
      dealerPrincipleId: val.dealerPrincipleId,
      principleName: val.principleName,
      principleSurname: val.principleSurname,
      principleIDNumber: val.principleIDNumber,
      contactNumber: val.contactNumber ? val.contactNumber?.replace(/\s/g, "") : null,
      email: val.email,
      creditVettingDocName: val.creditVettingDocName,
      creditVettingDocPath: val.creditVettingDocPath,
      dealerAddress: val.formatedAddress,
      createdUserId: val.createdUserId,
    }
    let api = this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.CREDIT_VETTING, finalObject, 1);
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.getDealerMaintenanceListData();
      }
      else
        this.getDealerMaintenanceListData();
      this.rxjsService.setDialogOpenProperty(false);
    });
  }
  dealerCreditVettingAvsCheck(val) {
    let finalObject = {
      surname: val.lastName,
      forename1: val.firstName,
      said: val.southAfricanId,
      isLegalEntity: val.isLegalEntity,
      isPerson: val.isPerson,
      companyRegistrationNumber: val.companyRegistrationNumber,
      dealerAddress: val.formatedAddress,
      phoneNo: val.phoneNumber,
      dealerBranchId: val.dealerBranchId,
      createdUserId: this.loggedInUserData.userId,
      principalAccountVerifications: [
        {
          accountHolder: val.firstName + ' ' + val.lastName,
          accountNumber: val.accountNo,
          accountType: val.accountTypeName,
          branchCode: val.bankBranchCode
        }
      ]
    }

    let api = this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.CREDIT_VETTING_AVS_CHECK, finalObject, 1);
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.getDealerMaintenanceListData();
      }
      else
        this.getDealerMaintenanceListData();
      this.rxjsService.setDialogOpenProperty(false);
    });
  }
  tabClick(e) {
    this.selectedTabIndex = e?.index;
    this.dataList = [];
    let queryParams = {};
    if (this.dealerId) {
      queryParams['tab'] = this.selectedTabIndex;
      queryParams['id'] = this.dealerId;
      queryParams['dealerTypeId'] = this.dealerTypeId;
      if (this.referenceId) {
        queryParams['referenceId'] = this.referenceId;
      }
    }
    this.onBreadCumbChange();
    this.onAfterTabChange(queryParams);
    this.getDealerMaintenanceListData();
  }

  onAfterTabChange(queryParams) {
    if (this.selectedTabIndex != 0 || !this.dealerId) {
      this.router.navigate([`../`], { relativeTo: this.activatedRoute, queryParams: queryParams });
    }
    if (this.selectedTabIndex == 0 && this.dealerId) {
      this.router.navigate([`../info/view`], { relativeTo: this.activatedRoute, queryParams: queryParams });
    }
  }

  onBreadCumbChange() {
    if (this.selectedTabIndex != 0) {
      this.primengTableConfigProperties.breadCrumbItems[2] = { displayName: this.primengTableConfigProperties?.tableComponentConfigs?.tabsList[this.selectedTabIndex]?.caption };
    }
    if (this.selectedTabIndex != 0 && this.dealerId && !this.referenceId) {
      this.primengTableConfigProperties.breadCrumbItems[1].relativeRouterUrl = '/dealer/dealer-maintenance';
    }
    if (!this.dealerId && this.selectedTabIndex == 0) {
      this.primengTableConfigProperties.breadCrumbItems[1].relativeRouterUrl = '';
    }
  }


  openAddEditPage(type: CrudType | string, editableObject?: object | string | any, value?: number | any): void {
    switch (type) {
      case CrudType.CREATE:
        if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canCreate) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(["./info/add-edit"], { relativeTo: this.activatedRoute });
            break;
          case 1:
            this.openDealerPrincipleAddEdit(null, null);
            break;
          case 2:
            this.router.navigate(['dealer/dealer-maintenance/branch/add-edit'],
              { queryParams: { dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, avsCheckStatus: editableObject?.avsCheckStatus } });
            break;
          case 3:
            this.router.navigate(['dealer/dealer-maintenance/branch-category/add-edit'],
              { queryParams: { dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, } });
            break;
          case 4:
            this.getDealerDocumentTypeDropdown({ dealerTypeId: this.dealerTypeId });
            break;
        }
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(["./info/view"], {
              relativeTo: this.activatedRoute, queryParams: {
                id: editableObject[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey],
                dealerTypeId: editableObject['dealerTypeId'],
              }
            });
            break;
          case 1:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            this.openDealerPrincipleAddEdit(CrudType.VIEW, editableObject);
            break;
          case 2:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            if (this.referenceId) {
              this.router.navigate(['dealer/dealer-maintenance/branch/add-edit'],
                { queryParams: { dealerId: this.dealerId, id: editableObject['dealerBranchId'], dealerTypeId: this.dealerTypeId, referenceId: this.referenceId, }, skipLocationChange: true });
            } else {
              this.router.navigate(['dealer/dealer-maintenance/branch/add-edit'],
                { queryParams: { dealerId: this.dealerId, id: editableObject['dealerBranchId'], dealerTypeId: this.dealerTypeId, avsCheckStatus: editableObject?.avsCheckStatus } });
            }
            break;
          case 3:
            if (this.referenceId) {
              this.router.navigate(['dealer/dealer-maintenance/branch-category/view'],
                { queryParams: { dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, dealerBranchId: editableObject?.dealerBranchId, referenceId: this.referenceId, }, skipLocationChange: true });
            } else {
              this.router.navigate(['dealer/dealer-maintenance/branch-category/view'],
                { queryParams: { dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, dealerBranchId: editableObject?.dealerBranchId } });
            }
            break;
        }
        break;
      case CrudType.EDIT:
        switch (this.selectedTabIndex) {
          case 1:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            if (editableObject && editableObject?.viewResult == 'AVS Verification') {
              if (editableObject.creditVettingStatus == true) {
                this.openDealerPrincipleCreditVetting(CrudType.EDIT, editableObject);
              } else {
                this.snackbarService.openSnackbar("Please Complete The Credit Vetting.", ResponseMessageTypes.WARNING);
              }
            }
            break;
          case 2:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            if (editableObject && editableObject?.viewResult == 'AVS Verification') {
              if (editableObject.avsCheckStatus == true) {
                this.openDealerBranchAVSCheck(CrudType.EDIT, editableObject);
              }
              else {
                this.snackbarService.openSnackbar("Please Complete The AVS Check.", ResponseMessageTypes.WARNING);
              }
            }
            break;
          case 4:
            if (!this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].canEdit) {
              return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
            }
            if (editableObject && editableObject?.viewResult?.toLowerCase() == 'comments history' && value == 'viewResult') {
              this.rxjsService.setGlobalLoaderProperty(true);
              this.openDealerCommentHistory('Comments History', editableObject);
            } else if (!this.referenceId && editableObject?.approvalStatus?.toLowerCase() != 'approved') {
              this.openDealerDocumentDialog([], editableObject, '15vh');
            } else {
              this.openDealerDocumentDialog([], editableObject, '15vh');
              // this.snackbarService.openSnackbar("This document can't be edited.", ResponseMessageTypes.WARNING);
            }
            break;
        }
        break;
    }
  }

  openDealerDocumentDialog(dealerDocumentTypeList, row?, height?) {
    const ref = this.dialogService.open(DealerDocumentsAddEditComponent, {
      header: row ? 'Update Dealer Document' : 'Create Dealer Document',
      showHeader: false,
      baseZIndex: 1000,
      width: '500px',
      data: {
        row: {
          ...row,
          dealerId: this.dealerId,
          userId: this.loggedInUserData.userId,
          createdUserId: this.loggedInUserData?.userId,
        },
        api: DealerModuleApiSuffixModels.DEALER_DOCUMENT,
        module: ModulesBasedApiSuffix.DEALER,
        dealerDocumentTypeList: dealerDocumentTypeList,
        dialogHeight: height,
      }
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.getDealerMaintenanceListData()
      }
      this.userService.openedPrimeDialog = [];
    });
  }
  openDealerPrincipleAddEdit(type: CrudType | string, editableObject?: object | string | any) {
    let isShowAction;
    // if (this.referenceId || editableObject?.approvalStatus?.toLowerCase() == 'approved') {
    //   isShowAction = true;
    // }
    const ref = this.dialogService.open(DealerPrincipleAddEditComponent, {
      header: editableObject ? 'Update Dealer Principal' : 'Add Dealer Principal',
      showHeader: false,
      baseZIndex: 1000,
      width: '58vw',
      // height: '500px',
      data: {
        row: editableObject,
        isShowAction: isShowAction,
      }
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.getDealerMaintenanceListData()
      }
      this.userService.openedPrimeDialog = [];
    });

  }
  openDealerPrincipleCreditVetting(type: CrudType | string, editableObject?: object | any) {
    const ref = this.dialogService.open(DealerCreditVettingComponent, {
      header: 'Credit Vetting Result',
      showHeader: false,
      baseZIndex: 1000,
      width: '80vw',
      data: {
        row: {
          ...editableObject,
          createdUserId: this.loggedInUserData?.userId,
          modifiedUserId: this.loggedInUserData?.userId
        }
      }
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.getDealerMaintenanceListData()
      }
      this.userService.openedPrimeDialog = [];
    });

  }
  openDealerBranchAVSCheck(type: CrudType | string, editableObject?: object | any) {
    const ref = this.dialogService.open(DealerAVSCheckComponent, {
      header: 'AVS Check',
      showHeader: false,
      baseZIndex: 1000,
      width: '62vw',
      data: {
        row: {
          ...editableObject,
          createdUserId: this.loggedInUserData?.userId,
          modifiedUserId: this.loggedInUserData?.userId
        }
      }
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.getDealerMaintenanceListData();
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  openDealerCommentHistory(header, data) {
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_DOCUMENT_COMMENT_HISTORY, undefined,
      false, prepareRequiredHttpParams({ dealerDocumentId: data?.dealerDocumentId }))
      .subscribe((res: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (res?.isSuccess && res?.statusCode == 200) {
          const ref = this.dialogService.open(DealerCommentsHistoryComponent, {
            header: header,
            showHeader: false,
            baseZIndex: 1000,
            width: '62vw',
            data: res?.resources,
          });
          this.userService.openedPrimeDialog.push(ref);
          ref.onClose.subscribe((result) => {
            this.userService.openedPrimeDialog = [];
          });
        }
      })
  }

  onChangeStatus(rowData?, index?) {
    let status;
    if (rowData['isActive']) {
      status = true
    } else {
      status = false
    }
    const ref = this.dialogService.open(PrimengStatusConfirmDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      width: '400px',
      data: {
        index: index,
        ids: rowData[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey],
        isActive: status,
        modifiedUserId: this.loggedInUserData?.userId,
        moduleName: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
        apiSuffixModel: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (!result) {
        this.getDealerMaintenanceListData(this.row["pageIndex"], this.row["pageSize"]);
      } else {
        this.getDealerMaintenanceListData(this.row["pageIndex"], this.row["pageSize"]);
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  onOneOrManyRowsDelete(rowData?: object) {
    if (this.selectedTabIndex == 4 && rowData['dealerDocumentStatus']?.toLowerCase() == 'approved') {
      this.snackbarService.openSnackbar("Once Approved Document can't be deleted", ResponseMessageTypes.WARNING);
      return;
    }
    if (rowData) {
      var deletableIds = rowData[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey];
    } else {
      if (this.selectedRows.length > 0) {
        var deletableIds = []
        this.selectedRows.forEach((element: any) => {
          deletableIds.push(element[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey])
        });
      }
    }
    const ref = this.dialogService.open(PrimengDeleteConfirmDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      width: '400px',
      data: {
        selectAll: (this.totalRecords == this.selectedRows.length) ? true : false,
        moduleName: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
        apiSuffixModel: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].deleteAPISuffixModel,
        method: 'delete',
        dataObject: {
          ids: this.selectedTabIndex == 2 && this.selectedRows.length > 0 ? deletableIds.join(',') : deletableIds,
          isDeleted: true,
          dealerId: this.dealerId,
          modifiedUserId: this.loggedInUserData?.userId,
        }
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.selectedRows = [];
        this.getDealerMaintenanceListData();
      }
      this.userService.openedPrimeDialog = [];
    });
  }


  getDealerMaintenanceListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    const addParams = (this.selectedTabIndex == 3) ? { dealerId: this.dealerId, isAll: true } : (this.selectedTabIndex == 4
      && this.referenceId) ? { dealerId: this.dealerId, dealerApprovalId: this.referenceId } :
      (this.selectedTabIndex != 0) ? { dealerId: this.dealerId } : {};
    otherParams = { ...otherParams, ...addParams, ...{ userId: this.loggedInUserData?.userId } };
    this.loading = true;
    let dealerModuleApiSuffixModels: DealerModuleApiSuffixModels;
    dealerModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    const moduleName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName;
    if (this.listSubscribtion && !this.listSubscribtion.closed) {
      this.listSubscribtion?.unsubscribe();
    }
    this.listSubscribtion = this.crudService.get(
      moduleName,
      dealerModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).pipe(map((res: IApplicationResponse) => {
      if (res?.resources) {
        res?.resources?.forEach(val => {
          if (this.selectedTabIndex == 1 || this.selectedTabIndex == 2) {
            val.viewResult = val?.isMigrationDealer ? '' : 'AVS Verification';
            // val.viewResult = 'AVS Verification';
            if (!val?.isMigrationDealer) {
              val.actionLabel = this.selectedTabIndex == 1 ? 'Credit Vetting' : 'AVS Check';
            } else {
              val.actionLabel = '';
            }
          }
          if (this.selectedTabIndex == 4) {
            val.viewResult = 'Comments History';
            val.reason = "";
          }
          if (this.selectedTabIndex == 0) {
            val.psiraExpiryDate = val.psiraExpiryDate ? this.datePipe.transform(val.psiraExpiryDate, 'dd-MM-yyyy') : '';
          }
          return val;
        })
      }
      return res;
    })).subscribe((data: IApplicationResponse) => {
      if (data?.isSuccess && data?.statusCode == 200) {
        this.observableResponse = data.resources;
        this.dataList = this.observableResponse;
        this.totalRecords = data.totalCount;
        if (!this.enableSubmitAction() && this.selectedTabIndex == 4) {
          this.isDisableCreateButton = true;
        } else {
          this.isDisableCreateButton = false;
        }
      } else {
        this.observableResponse = null;
        this.dataList = this.observableResponse;
        this.totalRecords = 0;
      }
      this.reset = false;
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
    }, error => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      this.observableResponse = null;
      this.dataList = this.observableResponse;
      this.totalRecords = 0;
    })
  }

  onApproveAction() {
    if (this.dataList?.length == 0) {
      this.snackbarService.openSnackbar("Please select atleast one document", ResponseMessageTypes.WARNING);
      return;
    }
    const reqObj = {
      dealerId: this.dealerId,
      dealerApprovalId: this.referenceId,
      dealerApprovalActionStatus: true,
      reason: "Approved",
      createdUserId: this.loggedInUserData?.userId,
      dealerDocumentApprovalInsertDTO: [],
    };
    this.dataList.forEach(el => {
      if (el) {
        reqObj.dealerDocumentApprovalInsertDTO.push({
          dealerId: this.dealerId,
          dealerDocumentId: el?.dealerDocumentId,
          dealerApprovalId: this.referenceId,
          dealerDocumentActionStatus: el?.dealerDocumentActionStatus,
          reason: el?.reason,
          isActive: true,
          createdUserId: this.loggedInUserData?.userId,
        });
      }
    });
    this.isSubmitted = true;
    this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_APPROVAL, reqObj)
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          this.router.navigate(['/dealer/dealer-worklist']);
        }
        this.isSubmitted = false;
      })
  }

  onDeclineAction() {
    if (this.dataList?.length == 0) {
      this.snackbarService.openSnackbar("Please select atleast one document", ResponseMessageTypes.WARNING);
      return;
    }
    const reqObj = {
      dealerId: this.dealerId,
      dealerApprovalId: this.referenceId,
      dealerApprovalActionStatus: false,
      reason: "",
      createdUserId: this.loggedInUserData?.userId,
      dealerDocumentApprovalInsertDTO: [],
    };
    this.dataList.forEach(el => {
      if (el) {
        reqObj.dealerDocumentApprovalInsertDTO.push({
          dealerId: this.dealerId,
          dealerDocumentId: el?.dealerDocumentId,
          dealerApprovalId: el?.dealerApprovalId,
          dealerDocumentActionStatus: el?.dealerDocumentActionStatus,
          reason: el?.reason,
          isActive: true,
          createdUserId: this.loggedInUserData?.userId,
        });
      }
    });
    this.openDealerDeclineReason('Decline Reason', reqObj);
  }

  openDealerDeclineReason(header, data) {
    const ref = this.dialogService.open(DealerDocumentDeclineReasonComponent, {
      header: header,
      showHeader: false,
      baseZIndex: 1000,
      width: '450px',
      data: {
        row: data,
        module: ModulesBasedApiSuffix.DEALER,
        api: DealerModuleApiSuffixModels.DEALER_APPROVAL,
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.router.navigate(['/dealer/dealer-worklist']);
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  enableApproveBtn() {
    return this.dataList?.every(el => el?.dealerDocumentActionStatus == true);
  }

  enableDeclineBtn() {
    const items = this.dataList?.filter(el => el?.dealerDocumentActionStatus == false);
    return items.length > 0 && items?.every(el => (el?.reason != undefined && el?.reason != null && el?.reason != ''));
  }

  onSubmitAction() {
    if (!this.enableSubmitAction()) {
      return;
    }
    const message = `Are you sure want to final submit the dealer?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else {
        this.onValidateDealerDocument();
      }
    });
  }

  onValidateDealerDocument() {
    this.rxjsService.setDialogOpenProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_DOCUMENT_VALIDATION, null, false, prepareRequiredHttpParams({ dealerId: this.dealerId, userId: this.loggedInUserData?.userId }))
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          if (res?.resources?.isSuccess) {
            this.onSubmit();
          } else if (!res?.resources?.isSuccess) {
            this.openDialog(res?.resources?.responseMessage);
          }
        }
        this.rxjsService.setDialogOpenProperty(false);
      })
  }

  openDialog(message) {
    const dialogData = new ConfirmDialogModel("Alert", message);
    this.alertDialog = this.dialogService.open(PrimengConfirmDialogPopupComponent, {
      showHeader: false,
      width: "450px",
      data: { ...dialogData, isAlert: true, isClose: true },
      baseZIndex: 5000,
    });
    this.userService.openedPrimeDialog.push(this.alertDialog);
    this.alertDialog.onClose.subscribe(dialogResult => {
      if (dialogResult) {
        return;
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  onSubmit() {
    const reqObj = {
      dealerId: this.dealerId,
      createdUserId: this.loggedInUserData?.userId,
    }
    this.isSubmitted = true;
    this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_APPROVAL_REQUEST, reqObj)
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          this.onCRUDRequested('get');
        }
        this.isSubmitted = false;
      })
  }

  enableSubmitAction() {
    let enableSubmitDataList = [];
    this.dataList?.find(element => {
      if (element?.canSubmit == true && element?.approvalStatus?.toLowerCase() != "approved") {
        enableSubmitDataList.push(element)
      }
    });
    if (enableSubmitDataList?.length > 0) {
      return enableSubmitDataList?.every(el => el?.approvalStatus?.toLowerCase() == null || el?.approvalStatus?.toLowerCase() != "approved");
    }
    else {
      return this.dataList?.every(el => el?.approvalStatus?.toLowerCase() == null);
    }
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  ngOnDestroy() {
    if (this.listSubscribtion) {
      this.listSubscribtion?.unsubscribe();
    }
    if (this.dealerDocumentSubscription) {
      this.dealerDocumentSubscription?.unsubscribe();
    }
  }
}
